<template lang="html">
  <div class="wrapper">
    <p v-if="timerSecs > 1">WARNING ! <span v-if="timerSecs > 2">WARNING !</span></p>
    <p v-if="timerSecs > 3.5">DANGER ASSESSMENT: <span v-if="timerSecs > 4.5">CRITICAL</span></p>
    <br>
    <p v-if="timerSecs > 6">INITIATING __LOCKDOWN__ PROTOCOL
      <span v-if="timerSecs > 7">.</span>
      <span v-if="timerSecs > 7.25">.</span>
      <span v-if="timerSecs > 7.5">.</span>
    </p>
    <br>
    <p v-if="timerSecs > 9">REROUTING POWER FROM [MOBILITY] TO [SHIELDS]
      <span v-if="timerSecs > 10">.</span>
      <span v-if="timerSecs > 10.25">.</span>
      <span v-if="timerSecs > 10.5">.</span>
    </p>
    <p v-if="timerSecs > 11">COMPLETE !</p>
    <p v-if="timerSecs > 12">[MOBILITY] OFFLINE ╳</p>
    <br>
    <p v-if="timerSecs > 13.5">REROUTING POWER FROM [WEAPONS] TO [LIFE_SUPPORT]
      <span v-if="timerSecs > 14.5">.</span>
      <span v-if="timerSecs > 14.75">.</span>
      <span v-if="timerSecs > 15">.</span>
    </p>
    <p v-if="timerSecs > 15.5">COMPLETE !</p>
    <p v-if="timerSecs > 16.5">[WEAPONS] OFFLINE ╳</p>
    <br>
    <p v-if="timerSecs > 18">SEALING [BLAST_DOOR]
      <span v-if="timerSecs > 19">.</span>
      <span v-if="timerSecs > 19.25">.</span>
      <span v-if="timerSecs > 19.5">.</span>
    </p>
    <p v-if="timerSecs > 20">COMPLETE !</p>
    <p v-if="timerSecs > 21">[EGRESS] OFFLINE ╳</p>
    <br>
    <p v-if="timerSecs > 22.5">__LOCKDOWN__ COMPLETE</p>
    <br>
    <p v-if="timerSecs > 24">STAND BY
      <span v-if="timerSecs > 25">.</span>
      <span v-if="timerSecs > 25.25">.</span>
      <span v-if="timerSecs > 25.5">.</span>
    </p>
    <br>
    <p v-if="timerSecs > 27">STAND BY
      <span v-if="timerSecs > 27.5">.</span>
      <span v-if="timerSecs > 28">.</span>
      <span v-if="timerSecs > 28.5">.</span>
    </p>
    <br>
    <p v-if="timerSecs > 30.5">STAND BY
      <span v-if="timerSecs > 31.5">.</span>
      <span v-if="timerSecs > 32.5">.</span>
      <span v-if="timerSecs > 33.5">.</span>
    </p>
    <br>
    <transition name="fade">
      <button v-if="timerSecs > 35" @click="continueHandler">Continue</button>
    </transition>
    <!-- <div class="skip-container">
      <router-link to="/welcome">Skip intro</router-link>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'Intro',
  data() {
    return {
      timer: 0,
    }
  },
  computed: {
    timerSecs() {
      return this.timer / 1000;
    },
  },
  methods: {
    count() {
      let delay = 250;
      if (this.timer < 40000 && this.$router.currentRoute.name === 'intro') {
        setTimeout(() => {
          this.timer += delay;
          this.count();
          window.scrollTo({
            top: document.body.scrollHeight,
            left: 0,
            behavior: 'smooth',
          });
        }, delay);
      }
    },
    continueHandler() {
      this.$router.push('/welcome');
    },
  },
  mounted() {
    this.count();
  },
}
</script>

<style scoped>
p {
  margin-bottom: 10px;
  margin-top: 0;
}

p::before {
  content: "> ";
  color: var(--tertiary-color);
}

.skip-container {
  position: absolute;
  bottom: 25px;
  right: 28px;
}

br {
  user-select: none;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
